// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportDataModel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import ImportDataModelTenant from 'logic/models/Izenda.ImportDataModelTenant';
import PagingModel from 'share/components/controls/DataGrid/helpers/Izenda.PagingModel';
import commonMessages from 'share/messages/Izenda.CommonMessages';
import constants from 'logic/data/Izenda.CopyManagementConstants';

import { split, find, last, filter, includes, map, isNil } from 'lodash/fp';

export default class ImportDataModel {
  @observable loaded = false;
  @observable fileId = '';
  @observable name = '';
  @observable selectedDestinationTenantIDs  = null;
  @observable importDataModelTenants = [];
  @observable allDestinationTenantList = [];
  @observable selectedTenant = null;
  @observable alertMessage = commonMessages.EMPTY_MESSAGE;

  sourceConnections = [];
  pageInfo = new PagingModel(constants.DESTINATION_SORT_DIR);

  /**
   * Create Import Data Model
   */
  @action
  create(dataModel, sourceConnections, tenantList) {
    this.name = dataModel.name;
    this.fileId = dataModel.id;
    this.sourceConnections = sourceConnections;
    this.allDestinationTenantList = tenantList;
    this.loaded = true;
  }

  /**
   * Update Selected Tenants For Destination
   */
  @action
  updateSelectedTenantsForDestination(tenantId){
    this.selectedDestinationTenantIDs = tenantId;
    if(!this.selectedDestinationTenantIDs){
      this.importDataModelTenants = [];
    }else{
      const selectedTenants = split(',', this.selectedDestinationTenantIDs);
      if(selectedTenants.length > this.importDataModelTenants.length){
        const newTenantId = last(selectedTenants);
        const newTenantInfo = find(t => t.id === newTenantId, this.allDestinationTenantList);
        const newTenant = new ImportDataModelTenant({
          tenantId: newTenantInfo.id,
          tenantName: newTenantInfo.name,
          sourceConnections: this.sourceConnections
        });
        this.importDataModelTenants.push(newTenant);
      }else{
        this.importDataModelTenants = filter(t => includes(t.tenantId, selectedTenants), this.importDataModelTenants);
      }
    }
  }

  /**
   * Set selected tenant
   */
  @action
  setSelectedTenant(tenant, updateConnections, destinationConnections){
    this.resetAlertMessage();
    if(updateConnections){
      tenant.destinationConnections = destinationConnections;
    }
    this.selectedTenant = tenant;
  }

    /**
   * Reset selected tenant
   */
  @action
  resetSelectedTenant(){
    this.resetAlertMessage();
    this.selectedTenant = null;
  }

    /**
   *  Reset errorMessages
   */
  @action
  resetAlertMessage() {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  }

  /**
   *  Update errorMessages
   */
  @action
  showAlertMessage(type, message) {
    const msg = {
      type: type,
      message: message
    };
    this.alertMessage = msg;

    return null;
  }

  /**
   * Build data
   */
  @action
  buildData(){
    const tenants = isNil(this.selectedTenant) ? this.importDataModelTenants : [ this.selectedTenant ]; 
    return {
      dataModelFileId: this.fileId,
      destinationTenants: map(t => t.buildData(), tenants)
    };
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportDataModel.js